export const SUPPORT_PHONE_DISPLAY = "(866) 638-8013";
export const SUPPORT_PHONE_TEL = "+18666388013";
